import { render } from "./cart-group.vue?vue&type=template&id=524e2b9a"
import script from "./cart-group.vue?vue&type=script&lang=js"
export * from "./cart-group.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__